import { defineStore } from 'pinia'

export const useUserStore = defineStore('user', {
  state: () => ({
    usuario: {
      foto: '' as string | null,
    },
  }),
}); 